import * as p from '@clack/prompts'
import { openBrowser } from '@cli-utils/process.js'
import pc from 'picocolors'
import { openBrowserVercelNeon } from './open-browser-vercel-neon.js'

export function openBrowserVercelNeonResource(url: string | undefined): void {
  if (!url) {
    openBrowserVercelNeon()
    return
  }

  openBrowser(url)
  p.log.info(
    `Opening Vercel... Copy the Neon ${pc.cyan('DATABASE_URL')} from the database dashboard, then paste it below.`
  )
}
